var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('TabView',[_c('TabPanel',{attrs:{"header":"รายงานเหตุเพลิงไหม้ (ว.๘/๐๐๑)"}},[_c('report-daily-fire')],1),_c('TabPanel',{attrs:{"header":"รายงานเหตุสาธารณภัยและบริการประชาชน"}},[_c('report-daily-disaster')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }